module.exports = __webpack_public_path__ + "img/534-09fd11.png";